import {
    useEffect,
    useState
} from 'react';

import {

    getStories,

    insertStory,

    updateStory,

    deleteStory,

    getStoryComments,

    deleteStoryComment,

    insertStoryComment

} from '../../../api/adminApi';

import './AppStoryManage.css';

/**
 * 이야기 아이템
 */
interface Story {

    id: number;

    title: string;

    content: string;
}

/**
 * 이야기 댓글 아이템
 */
interface StoryComment {

    id: number;

    nickname: string;

    content: string;

    createdAt?: string;
}

/**
 * 댓글 입력 폼 상태
 */
interface CommentInput {

    content: string;
}

const AppStoryManage = () => {

    /**
     * 이야기 목록
     */
    const [stories, setStories] =
        useState<Story[]>([]);

    /**
     * 등록용 내용
     */
    const [content, setContent] =
        useState('');

    /**
     * 수정 모달 여부
     */
    const [openModal, setOpenModal] =
        useState(false);

    /**
     * 수정 중 이야기
     */
    const [editStory, setEditStory] =
        useState<Story | null>(null);

    /**
     * 댓글 펼침 상태 (스토리별)
     */
    const [openComments, setOpenComments] =
        useState<Record<number, boolean>>({});

    /**
     * 스토리별 댓글 목록
     */
    const [storyComments, setStoryComments] =
        useState<Record<number, StoryComment[]>>({});

    /**
     * 스토리별 댓글 입력 폼
     */
    const [commentInputs, setCommentInputs] =
        useState<Record<number, CommentInput>>({});

    useEffect(() => {

        loadStories();

    }, []);

    /* =========================
     *  이야기 기본 기능
     * ========================= */
    const loadStories = async () => {

        const response =
            await getStories();

        setStories(
            response.data
        );
    };

    const handleInsert = async () => {

        if (!content.trim()) {

            alert(
                '내용을 입력하세요'
            );

            return;
        }

        await insertStory({

            title: '',

            content

        });

        setContent('');

        loadStories();
    };

    const handleDelete = async (
        id: number
    ) => {

        if (
            !window.confirm(
                '삭제하시겠습니까?'
            )
        ) {

            return;
        }

        await deleteStory(id);

        loadStories();
    };

    const handleUpdate = async () => {

        if (!editStory) {

            return;
        }

        await updateStory(
            editStory.id,
            {

                title: '',

                content:
                editStory.content

            }
        );

        setOpenModal(false);

        loadStories();
    };

    /* =========================
     *  댓글 기능
     * ========================= */
    const toggleComments = async (
        storyId: number
    ) => {

        const willOpen =
            !openComments[storyId];

        setOpenComments((prev) => ({

            ...prev,

            [storyId]:
                willOpen

        }));

        if (
            willOpen
            && !storyComments[storyId]
        ) {

            try {

                const response =
                    await getStoryComments(
                        storyId
                    );

                setStoryComments((prev) => ({

                    ...prev,

                    [storyId]:
                        response.data

                }));

            } catch (e) {

                console.error(e);

                alert(
                    '댓글을 불러오지 못했습니다.'
                );
            }
        }

        // 댓글 폼을 열 때 입력값 초기화
        if (willOpen) {

            setCommentInputs((prev) => ({

                ...prev,

                [storyId]:
                {

                    content: ''

                }

            }));
        }
    };

    const handleCommentChange = (
        storyId: number,
        field: 'content',
        value: string
    ) => {

        setCommentInputs((prev) => ({

            ...prev,

            [storyId]:
                {

                    ...(prev[storyId]
                        || {

                            content:
                                ''

                        }),

                    [field]:
                        value

                }

        }));
    };

    const handleInsertComment = async (
        storyId: number
    ) => {

        const input =
            commentInputs[storyId]
            || {

                content:
                    ''

            };

        if (
            !input.content.trim()
        ) {

            alert(
                '내용을 입력하세요'
            );

            return;
        }

        try {

            await insertStoryComment(
                storyId,
                '운영자',
                input.content
            );

            // 댓글 다시 불러오기
            const response =
                await getStoryComments(
                    storyId
                );

            setStoryComments((prev) => ({

                ...prev,

                [storyId]:
                    response.data

            }));

            // 입력 초기화
            setCommentInputs((prev) => ({

                ...prev,

                [storyId]:
                    {

                        content:
                            ''

                    }

            }));

        } catch (e) {

            console.error(e);

            alert(
                '댓글 등록에 실패했습니다.'
            );
        }
    };

    const handleDeleteComment = async (
        storyId: number,
        commentId: number
    ) => {

        if (
            !window.confirm(
                '댓글을 삭제하시겠습니까?'
            )
        ) {

            return;
        }

        try {

            await deleteStoryComment(
                commentId
            );

            setStoryComments((prev) => {

                const list =
                    prev[storyId]
                    || [];

                return {

                    ...prev,

                    [storyId]:
                        list.filter(
                            (c) =>
                                c.id
                                !== commentId
                        )

                };
            });

        } catch (e) {

            console.error(e);

            alert(
                '댓글 삭제에 실패했습니다.'
            );
        }
    };

    /* =========================
     *  렌더링
     * ========================= */
    return (

        <div className="story-manage">

            <h2 className="story-manage-title">
                이야기 관리
            </h2>

            {/* 이야기 등록 */}
            <div className="story-form">

                <textarea

                    className="story-textarea"

                    value={content}

                    placeholder="이야기 내용 입력"

                    onChange={(e) =>
                        setContent(
                            e.target.value
                        )
                    }
                />

                <button
                    className="story-save-button"
                    onClick={
                        handleInsert
                    }
                >
                    등록
                </button>

            </div>

            {/* 이야기 리스트 */}
            <div className="story-list">

                {
                    stories.map((item) => (

                        <div
                            key={item.id}
                            className="story-card"
                        >

                            <div className="story-header">

                                <div className="story-info">

                                    <p className="story-content-text">
                                        {item.content}
                                    </p>

                                </div>

                                <div className="story-actions">

                                    <button
                                        className="story-edit-button"
                                        onClick={() => {

                                            setEditStory(
                                                item
                                            );

                                            setOpenModal(
                                                true
                                            );
                                        }}
                                    >
                                        수정
                                    </button>

                                    <button
                                        className="story-delete-button"
                                        onClick={() =>
                                            handleDelete(
                                                item.id
                                            )
                                        }
                                    >
                                        삭제
                                    </button>

                                    <button
                                        className="story-comment-button"
                                        onClick={() =>
                                            toggleComments(
                                                item.id
                                            )
                                        }
                                    >
                                        {
                                            openComments[item.id]
                                                ? '댓글 닫기'
                                                : '댓글 보기'
                                        }
                                    </button>

                                </div>

                            </div>

                            {/* 댓글 영역 */}
                            {
                                openComments[item.id]
                                && (
                                    <div className="story-comment-section">

                                        <h4 className="story-comment-title">
                                            댓글
                                        </h4>

                                        {/* 댓글 등록 폼 */}
                                        <div className="story-comment-form">

                                            <textarea
                                                className="story-comment-content-input"
                                                placeholder="댓글 내용"
                                                value={
                                                    commentInputs[item.id]
                                                        ?.content
                                                        || ''
                                                }
                                                onChange={(e) =>
                                                    handleCommentChange(
                                                        item.id,
                                                        'content',
                                                        e.target.value
                                                    )
                                                }
                                            />

                                            <button
                                                className="story-comment-submit-button"
                                                onClick={() =>
                                                    handleInsertComment(
                                                        item.id
                                                    )
                                                }
                                            >
                                                등록
                                            </button>

                                        </div>

                                        <div className="story-comment-list">

                                            {
                                                (storyComments[item.id] || []).map(
                                                    (comment) => (

                                                        <div
                                                            key={comment.id}
                                                            className="story-comment-item"
                                                        >

                                                            <div className="story-comment-header">

                                                                <span className="story-comment-nickname">
                                                                    {comment.nickname}
                                                                </span>

                                                                {
                                                                    comment.createdAt
                                                                    && (
                                                                        <span className="story-comment-date">
                                                                            {comment.createdAt}
                                                                        </span>
                                                                    )
                                                                }

                                                            </div>

                                                            <p className="story-comment-content">
                                                                {comment.content}
                                                            </p>

                                                            <div className="story-comment-actions">

                                                                <button
                                                                    className="story-comment-delete-button"
                                                                    onClick={() =>
                                                                        handleDeleteComment(
                                                                            item.id,
                                                                            comment.id
                                                                        )
                                                                    }
                                                                >
                                                                    삭제
                                                                </button>

                                                            </div>

                                                        </div>

                                                    )
                                                )
                                            }

                                            {
                                                (!storyComments[item.id]
                                                    || storyComments[item.id].length === 0)
                                                && (
                                                    <p className="story-comment-empty">
                                                        등록된 댓글이 없습니다.
                                                    </p>
                                                )
                                            }

                                        </div>

                                    </div>
                                )
                            }

                        </div>

                    ))
                }

            </div>

            {/* 이야기 수정 모달 */}
            {
                openModal
                && editStory
                && (
                    <div className="story-modal-overlay">

                        <div className="story-modal-box">

                            <h3 className="story-modal-title">
                                이야기 수정
                            </h3>

                            <textarea
                                className="story-modal-textarea"
                                value={
                                    editStory.content
                                }
                                onChange={(e) =>
                                    setEditStory({

                                        ...editStory,

                                        content:
                                        e.target.value

                                    })
                                }
                            />

                            <div className="story-modal-buttons">

                                <button
                                    className="story-modal-save-button"
                                    onClick={
                                        handleUpdate
                                    }
                                >
                                    저장
                                </button>

                                <button
                                    className="story-modal-cancel-button"
                                    onClick={() => {

                                        setOpenModal(
                                            false
                                        );

                                        setEditStory(
                                            null
                                        );

                                    }}
                                >
                                    취소
                                </button>

                            </div>

                        </div>

                    </div>
                )
            }

        </div>
    );
};

export default AppStoryManage;
